import { useEffect, useState } from "react";
import * as S from "./style";
import LayoutDetails from "../../../../components/LayoutModal/LayoutDetails";
import ImgLens from "../../../../assets/lens.png";
import axiosInstance from "services/axiosInstance";
import Loading from "../../../../components/Loading";
import { CurrencyFormat, formatPercentage } from "utils/CurrencyFormat";
//hooks
import useLoading from "../../../../hooks/useLoading";
//Interface
import { ILens } from "Interfaces/ILens";
// utils
import FormatarData from "utils/FormatData";

interface IDetails {
  isOpenModalDetails: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
}

export default function Details({
  isOpenModalDetails,
  setModalClose,
  selectedUrlId,
}: IDetails) {
  const [data, setData] = useState<ILens | null>(null);
  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(`lens/${selectedUrlId}`);
      console.log('details lente: ', response.data);
      setData(response.data);
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (selectedUrlId !== null) {
      fetchData();
    }
  }, [selectedUrlId]);

  if (isOpenModalDetails) {
    return (
      <LayoutDetails
        title="Detalhes da Lente"
        subTitle="Veja todos os detalhes disponíveis sobre a lente."
        setModalClose={setModalClose}>
        {isLoading || !data ? (
          <Loading />
        ) : (
          <S.Content>
            <S.Header>
              <S.ContentImage>
                <S.Image src={ImgLens} alt="Imagem Óculos" />
              </S.ContentImage>

              <S.ContentInfor>
                <S.Infor>
                  <p>Nome:</p>
                  <span>{data.name_lens || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Código de barra:</p>
                  <span>{data.barcode || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Preço:</p>
                  <span>{CurrencyFormat(parseFloat(data.price || "0"))}</span>
                </S.Infor>
              </S.ContentInfor>
            </S.Header>

            <S.Body>
              <S.Section>
                <S.ContentBody>
                  <S.InforBody>
                    <p>Tipo de Lente</p>
                    <span>{data.type_lens?.type_lens || "-"}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Filtro Azul</p>
                    <span>{data.filter ? "Filtro Azul" : "-"}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Surfaçagem</p>
                    <span>{data.surfacings?.surfacing || '-'}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Fotossensibilidade</p>
                    <span>
                      {data.sensitivity?.sensitivity || "-"} (
                      {data.sensitivity?.percentage || "-"}%)
                    </span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Laboratório</p>
                    <span>{data.laboratory?.laboratory || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>Índice</p>
                    <span>{data.indices?.index || "-"}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Antirreflexo</p>
                    <span>{data.treatment?.treatment || "-"}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Altura</p>
                    <span>{data.heights?.height || '-'}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Diâmetro</p>
                    <span>{data.diameters?.diameter || '-'}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Lente no Laboratório</p>
                    <span>{data.laboratory_lens || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>Esférico</p>
                    <span>
                      {data.spherical_start || "-"}/
                      {data.spherical_end || "-"}
                    </span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Cilindro</p>
                    <span>
                      {data.cylindrical_start || "-"}/
                      {data.cylindrical_end || "-"}
                    </span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Adição</p>
                    <span>
                      {data.addition_start || "-"}/
                      {data.addition_end || "-"}
                    </span>
                  </S.InforBody>
                </S.ContentBody>
              </S.Section>

              <S.FeaturedSection>
                <S.ContentBody>
                  <S.InforBody>
                    <p>Entrada Mínima R$</p>
                    <span>
                      {CurrencyFormat(parseFloat(data.minimum_value || "0"))}
                    </span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Valor da Venda</p>
                    <span>{CurrencyFormat(parseFloat(data.price || "0"))}</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>Custo</p>
                    <span>{CurrencyFormat(parseFloat(data.cost || '0'))}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Lucro</p>
                    <span>{formatPercentage(parseFloat(data.profit || '0'))}</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.InforBody>
                  <p>Prazo de entrega</p>
                  <span>{data.delivery && data.delivery > 1 ? `${data.delivery} dias` : `${data.delivery} dia` || '0'} </span>
                </S.InforBody>
              </S.FeaturedSection>

              <S.InforBody>
                <S.InforSmall>Cadastrado em: {FormatarData(data.created_at || "-")}</S.InforSmall>
                <S.InforSmall>Ultima atualização em: {FormatarData(data.updated_at) || "-"}</S.InforSmall>
              </S.InforBody>
            </S.Body>
          </S.Content>
        )
        }
      </LayoutDetails >
    );
  }
  return null;
}
